export enum CategoryTitles {
  Engine = 'Engine',
  Cloud = 'Cloud',
  Video = 'Video',
  DevForum = 'DevForum',
}

export default CategoryTitles;
